<div class="verification-container">
  <div class="verification-box">
    <div class="logo-container">
        <img [src]="logoPath" alt="Nevada Department of Education Logo" class="logo-header">
    </div>
    
    <div class="divider-horizontal"></div>
    
    <div class="content-area">
      <div class="header-section">
        <h1 class="title">Phone Verification</h1>
        <p class="description">Enter the 6-digit verification code sent to your phone.</p>
      </div>
      
      <div class="otp-section">
        <div class="otp-label">
          <span>Verification Code</span>
          <span class="required">*</span>
        </div>
        
        <div class="otp-input-container">
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" [(ngModel)]="otp[0]" (input)="onOtpChange(0, $event)" (keypress)="onlyNumeric($event)" #otpFirst>
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" [(ngModel)]="otp[1]" (input)="onOtpChange(1, $event)" (keypress)="onlyNumeric($event)">
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" [(ngModel)]="otp[2]" (input)="onOtpChange(2, $event)" (keypress)="onlyNumeric($event)">
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" [(ngModel)]="otp[3]" (input)="onOtpChange(3, $event)" (keypress)="onlyNumeric($event)">
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" [(ngModel)]="otp[4]" (input)="onOtpChange(4, $event)" (keypress)="onlyNumeric($event)">
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" [(ngModel)]="otp[5]" (input)="onOtpChange(5, $event)" (keypress)="onlyNumeric($event)">
        </div>
        
        <div class="timer-section">
          <button class="resend-btn" (click)="resendOtp()" [disabled]="timerActive  || isResending">Resend Code</button>
          <div class="timer" [ngClass]="{'timer-warning': timeRemaining <= 15}">
            {{ timerDisplay }}
          </div>
        </div>

        <div *ngIf="errorMessage" class="error-message1">
          {{ errorMessage }}
        </div>
        
        <div class="action-buttons">
          <button class="verify-btn" (click)="verifyOtp()">Verify Code</button>
          <button class="cancel-btn" (click)="cancel()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>